import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { type KnowledgeItem } from "./model";

export default function ContactAssociation({ item, compact = false }: { item: KnowledgeItem; compact?: boolean }) {
  if (!item.associatedContact) return null;
  const name = item.associatedContact.name;
  return <span className={`flex items-center gap-2 text-muted-foreground ${compact ? "text-sm" : "mt-1.5 text-xs"}`}>
    <Avatar className="h-6 w-6" aria-hidden="true">
      <AvatarFallback className="bg-primary font-heading text-xs font-semibold text-primary-foreground">
        {name.trim().charAt(0).toUpperCase() || "?"}
      </AvatarFallback>
    </Avatar>
    <span className="min-w-0 whitespace-normal break-words">{!compact && "Associated with "}{name}</span>
  </span>;
}
